import React, { Dispatch, SetStateAction, useEffect, useState } from 'react'

import { TextareaAutosize, styled } from '@mui/material'

const TextAreaAutoSize = styled(TextareaAutosize)(({ theme }) => ({
  '.MuiOutlinedInput-notchedOutline': {
    border: 'solid',
    boxShadow: 'none',
    borderRadius: 'var(--flo-border-radius-lg)',
    borderWidth: 'var(--flo-border-width-2)',
    borderColor: 'var(--flo-gray-light-color)'
  },
  '& input': {
    borderRadius: '0px'
  },
  '& label.Mui-focused': {
    color: 'green'
  }
}))

interface BulletedTextEditorProps {
  textAreaContent: string
  setTextAreaContent: Dispatch<SetStateAction<string>>
}

const BulletedTextEditor: React.FC<BulletedTextEditorProps> = ({ textAreaContent, setTextAreaContent }) => {
  const [currentCaretPosition, setCurrentCaretPostion] = useState<number>(0)
  const [enterPressed, setEnterPressed] = useState<boolean>(false)
  const [backPressed, setBackPressed] = useState<boolean>(false)

  const element: HTMLTextAreaElement = document?.getElementById('long-desc-text-area') as HTMLTextAreaElement

  useEffect(() => {
    if (enterPressed) element?.setSelectionRange(currentCaretPosition + 3, currentCaretPosition + 3)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enterPressed])

  useEffect(() => {
    if (backPressed) element?.setSelectionRange(currentCaretPosition - 3, currentCaretPosition - 3)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [backPressed])

  const handleKeyUp = async (event: any) => {
    setEnterPressed(false)
    setBackPressed(false)
    const currentTarget = event?.currentTarget

    // const precedingRows = currentTarget?.value?.substr(0, currentTarget?.selectionStart)?.split('\n');
    // const currentRowIndex = precedingRows?.length - 1;

    // const allRows = currentTarget?.value?.split(`\n`);
    // const lastRowIndex = (currentTarget?.value?.match(/\n/g) || [])?.length;

    // const precedingCurrentRowText = precedingRows?.[currentRowIndex];
    // const latterCurrentRowText = allRows?.[currentRowIndex].replace(precedingCurrentRowText, "");

    const precedingText = currentTarget?.value?.substr(0, currentTarget?.selectionStart)
    const latterText = currentTarget?.value?.slice(precedingText.length, currentTarget?.value?.length)
    setCurrentCaretPostion(currentTarget?.selectionStart)

    if (event.keyCode === 13 && !event.shiftKey) {
      const modifiedText = precedingText + '•  ' + latterText
      currentTarget?.focus()
      setTextAreaContent(modifiedText)
      setEnterPressed(true)
    } else if (event.keyCode === 8) {
      if (precedingText?.substr(precedingText?.length - 2) === '• ' && precedingText?.length > 2) {
        setBackPressed(true)
        const modifiedText = precedingText?.slice(0, -3) + latterText
        setTextAreaContent(modifiedText)
      }
    }
  }

  const handleChange = (event: any) => {
    setEnterPressed(false)
    setBackPressed(false)
    if (event?.target?.selectionStart > 2) setTextAreaContent(event.target.value)
  }

  const handleFocus = (event: any) => {
    if (textAreaContent === '') {
      setTextAreaContent('•  ')
    }
  }

  const handleOnBlur = (event: any) => {
    if (textAreaContent?.trim() === '•') {
      setTextAreaContent('')
    }
  }

  return (
    <TextAreaAutoSize
      id={'long-desc-text-area'}
      placeholder={'Enter long description'}
      maxRows={6}
      minRows={1}
      onKeyUp={handleKeyUp}
      onMouseUp={handleKeyUp}
      onFocus={handleFocus}
      onBlur={handleOnBlur}
      onChange={handleChange}
      value={textAreaContent}
      style={{
        width: '100%',
        borderRadius: 8,
        border: '1px solid #f0f0f0',
        padding: '0.75rem 1rem',
        minWidth: '100%',
        maxWidth: '100%',
        lineHeight: '1.2rem',
        fontSize: 16,
        letterSpacing: 0.5,
        color: '#4d4d4d',
        fontFamily: 'sans-serif',
        boxShadow: '0.5px 0.5px 2px 0px #f0f0f0',
        MozUserFocus: 'select-all'
      }}
    />
  )
}

export default BulletedTextEditor
